var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sg-img',{attrs:{"do-not-lazy-load":!_vm.lazyLoad,"src":_vm.url,"placeholder-ratio":_vm.placeholderRatio,"alt":"Product Image"}})}
var staticRenderFns = []

export { render, staticRenderFns }